define(["react","mobx-state-tree","prop-types","jquery","gemini/lib/@waca/dashboard-common/dist/core/APIFactory","react-dom","mobx-react","polyglot","ca-ui-toolkit"], function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_19__, __WEBPACK_EXTERNAL_MODULE_25__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * Gets the number of filter items
 * @param {object} localFilter the filter applied.
 * @return the number of filter items applied. If filter number is not applicable, return null
 */
var getNumberOfFilterItems = exports.getNumberOfFilterItems = function getNumberOfFilterItems(localFilter) {
	if (localFilter) {
		if (localFilter.operator === 'in' || localFilter.operator === 'notin' || localFilter.operator === 'isnull') {
			return localFilter.values.length;
		}
	}
	return null;
};

// Scrollable drag constants
var SCROLL_DRAG_DISTANCE = 20;
var handleScroll = exports.handleScroll = function handleScroll(e, scrollableContainer, onScrollCallback) {
	var boundingRect = scrollableContainer.getBoundingClientRect();
	var rect = {
		top: boundingRect.top,
		bottom: boundingRect.bottom
	};
	if (e.type === 'touchmove') {
		var coords = e.touches[0];
		if (coords) {
			e.clientX = coords.clientX;
			e.clientY = coords.clientY;
		}
	}
	if (!e.clientX || !e.clientY) {
		return;
	}
	var position = {
		x: e.clientX,
		y: e.clientY
	};
	var distanceBottom = rect.bottom - position.y;
	var distanceTop = position.y - rect.top;
	var isScrollingBottom = distanceBottom > 0 && distanceBottom < SCROLL_DRAG_DISTANCE;
	var isScrollingTop = distanceTop > 0 && distanceTop < SCROLL_DRAG_DISTANCE;
	var distanceY = 0;
	if (isScrollingTop && isScrollingBottom) {
		isScrollingTop = distanceTop > distanceBottom;
		isScrollingBottom = !isScrollingTop;
	}
	if (isScrollingBottom) {
		distanceY = SCROLL_DRAG_DISTANCE - distanceBottom;
	} else if (isScrollingTop) {
		distanceY = distanceTop - SCROLL_DRAG_DISTANCE;
	}
	var newScrollTop = scrollableContainer.scrollTop + distanceY;
	if (newScrollTop <= 0) {
		newScrollTop = 0;
	} else {
		var maxScrollTop = scrollableContainer.scrollHeight - scrollableContainer.clientHeight;
		if (newScrollTop > maxScrollTop) {
			newScrollTop = maxScrollTop;
		}
	}
	if (scrollableContainer.scrollTop !== newScrollTop) {
		scrollableContainer.scrollTop = newScrollTop;
		if (onScrollCallback) {
			onScrollCallback();
		}
	}
};

/** this function returns datasource id that will be used in type in dropdown
 * it exercises following logic: 
 * 1. if there is active datasource id, use it
 * 2. else, use first datasource id in the list of datasources
 */
var getDataSourceIdTypeIn = exports.getDataSourceIdTypeIn = function getDataSourceIdTypeIn(dashboardApi) {
	var sourceId = dashboardApi.getActiveDataSourceId();
	if (!sourceId) {
		var dataSourceFeature = dashboardApi.getFeature('DataSources');
		if (dataSourceFeature.getDataSourceList().length > 0) {
			sourceId = dataSourceFeature.getDataSourceList()[0].getId();
		}
	}
	return sourceId;
};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(20);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(22)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/index.js??ref--2-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--2-4!./overlay.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/index.js??ref--2-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--2-4!./overlay.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = {"Bubble":{"top_multiple":["size","color"],"top_single":["categories"],"left":["y"],"bottom_single":["x"]},"Area":{"top_single":["series"],"left":["values"],"bottom_single":["categories"]},"Column":{"top_single":["color"],"left":["values"],"bottom_single":["categories"]},"Bar":{"top_single":["color"],"left":["categories"],"bottom_single":["values"]},"StackedColumn":{"top_single":["color"],"left":["values"],"bottom_single":["categories"]},"StackedBar":{"top_single":["color"],"left":["categories"],"bottom_single":["values"]},"Point":{"top_single":["series"],"left":["values"],"bottom_single":["categories"]},"DualAxis":{"top_multiple":["columnColor","lineColor"],"left":["columnValue"],"bottom_single":["categories"],"right":["lineValue"]},"DualAxis.legacy":{"left":["columnValue"],"bottom_single":["categories"],"right":["lineValue"]},"Marimekko":{"top_single":["color","categories"],"left":["values"],"bottom_single":["width"]},"Waterfall":{"left":["values"],"bottom_single":["categories"]},"Bullet":{"left":["actual"],"bottom_single":["goal"]},"Scatter":{"top_multiple":["color"],"top_single":["categories"],"left":["y"],"bottom_single":["x"]},"PackedBubble":{"top_multiple":["size","color"],"top_single":["categories"],"left":["y"],"bottom_single":["x"]},"HierarchicalPackedBubble":{"top_multiple":["size","color"],"bottom_single":["categories"]},"Wordle":{"top_multiple":["size","color"],"bottom_single":["categories"]},"Heatmap":{"top_multiple":["size","color"],"left":["categories"],"bottom_single":["series"]},"Treemap":{"top_multiple":["size","color"],"bottom_single":["categories"]},"Pie":{"top_single":["values"],"bottom_single":["categories"]},"Dial":{"top_single":["color"],"bottom_multiple":["categories","values"]},"KPI":{"top_single":["actual"],"bottom_single":["goal","sparkline.time"]},"Network":{"top_single":["categories","series"],"bottom_single":["values"]},"Line":{"top_single":["series"],"left":["values"],"bottom_single":["categories"]}}

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _DropZonesOverlayDOMAPI = __webpack_require__(11);

var _DropZonesOverlayDOMAPI2 = _interopRequireDefault(_DropZonesOverlayDOMAPI);

var _Overlay = __webpack_require__(12);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _OverlayConfig = __webpack_require__(7);

var _OverlayConfig2 = _interopRequireDefault(_OverlayConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var APIFactory = __webpack_require__(5);

var DropZonesOverlayDOM = function () {
	function DropZonesOverlayDOM(options) {
		_classCallCheck(this, DropZonesOverlayDOM);

		this._content = options.content;
		this._dashboard = options.features['Dashboard.API'];
		this._overlayState = options.features['DropZonesOverlayState'];
		this._logger = options.features['Dashboard.Logger'];
	}

	_createClass(DropZonesOverlayDOM, [{
		key: 'getAPI',
		value: function getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [_DropZonesOverlayDOMAPI2.default]);
			}
			return this._api;
		}
	}, {
		key: 'getContentMenuList',
		value: function getContentMenuList() {
			if (this._overlayState.isEnabled()) {
				return [{
					id: 'showHideOverlay',
					action: this.render
				}];
			}
			return [];
		}
	}, {
		key: 'render',
		value: function render() {
			var contentViewDOMFeature = this._content.getFeature('ContentViewDOM');
			var contentNode = contentViewDOMFeature && contentViewDOMFeature.getNode().querySelector('.widgetContent');
			if (contentNode) {
				var SLOTS_ID_POSITION_MAP = _OverlayConfig2.default;
				var visType = this._content.getFeature('Visualization').getType();
				if (!SLOTS_ID_POSITION_MAP[visType]) {
					// not a vis type that we want to show drop zones
					return null;
				}
				this._overLayParentNode = contentNode.querySelector('.dropZoneOverlay');
				if (this._overLayParentNode) {
					this.unmount(this._overLayParentNode);
				} else {
					this._overLayParentNode = document.createElement('div');
					this._overLayParentNode.classList.add('dropZoneOverlay');
					contentNode.appendChild(this._overLayParentNode);
				}
				_reactDom2.default.render(_react2.default.createElement(_Overlay2.default, {
					content: this._content,
					overlayModel: this._overlayState.getModel(),
					dashboard: this._dashboard,
					logger: this._logger,
					overlayParentNode: this._overLayParentNode
				}), this._overLayParentNode);
			}
		}
	}, {
		key: 'isMounted',
		value: function isMounted() {
			return !!this._overLayParentNode;
		}
	}, {
		key: 'unmount',
		value: function unmount() {
			if (this._overLayParentNode) {
				_reactDom2.default.unmountComponentAtNode(this._overLayParentNode);
			}
		}
	}, {
		key: 'reassessDropTarget',
		value: function reassessDropTarget(node) {
			if (!node) {
				var contentViewDOMFeature = this._content.getFeature('ContentViewDOM');
				node = contentViewDOMFeature && contentViewDOMFeature.getNode();
			}
			if (node) {
				var dnd = this._dashboard.getFeature('.DndManager');
				dnd.reassessContainer(node);
			}
		}
	}, {
		key: 'destroy',
		value: function destroy() {
			this.unmount();
			this._api = null;
		}
	}]);

	return DropZonesOverlayDOM;
}();

module.exports = DropZonesOverlayDOM;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var DropZonesOverlayDOMAPI = function () {
	function DropZonesOverlayDOMAPI() {
		_classCallCheck(this, DropZonesOverlayDOMAPI);
	}

	_createClass(DropZonesOverlayDOMAPI, [{
		key: "getContentMenuList",

		/**
   * @function DropZonesOverlayDOMAPI#getContentMenuList
   * @description Returns the menu action items for drop zones overlay (example: show/hide overlay)
   * @return {Object[]} list of menu action items
   */
		value: function getContentMenuList() {}

		/**
   * @function DropZonesOverlayDOMAPI#render
   * @description Renders drop zones overlay in a given container
   */

	}, {
		key: "render",
		value: function render() {}
	}, {
		key: "reassessDropTarget",
		value: function reassessDropTarget() {}
	}, {
		key: "isMounted",
		value: function isMounted() {}
	}]);

	return DropZonesOverlayDOMAPI;
}();

exports.default = DropZonesOverlayDOMAPI;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ErrorBoundary = __webpack_require__(13);

var _ErrorBoundary2 = _interopRequireDefault(_ErrorBoundary);

var _OverlayView = __webpack_require__(14);

var _OverlayView2 = _interopRequireDefault(_OverlayView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * The Overlay component
 */
var Overlay = function (_Component) {
	_inherits(Overlay, _Component);

	function Overlay() {
		_classCallCheck(this, Overlay);

		return _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).apply(this, arguments));
	}

	_createClass(Overlay, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    logger = _props.logger,
			    content = _props.content,
			    dashboard = _props.dashboard,
			    overlayModel = _props.overlayModel,
			    overlayParentNode = _props.overlayParentNode;

			return _react2.default.createElement(
				_ErrorBoundary2.default,
				{
					logger: logger
				},
				_react2.default.createElement(_OverlayView2.default, {
					content: content,
					dashboard: dashboard,
					overlayModel: overlayModel,
					overlayParentNode: overlayParentNode
				})
			);
		}
	}]);

	return Overlay;
}(_react.Component);

Overlay.propTypes = {
	logger: _propTypes2.default.object.isRequired,
	content: _propTypes2.default.object.isRequired,
	dashboard: _propTypes2.default.object.isRequired,
	overlayModel: _propTypes2.default.object.isRequired,
	overlayParentNode: _propTypes2.default.object.isRequired
};

exports.default = Overlay;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var ErrorBoundary = function (_Component) {
	_inherits(ErrorBoundary, _Component);

	function ErrorBoundary(props) {
		_classCallCheck(this, ErrorBoundary);

		var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

		_this.state = { hasError: false };
		return _this;
	}

	_createClass(ErrorBoundary, [{
		key: 'componentDidCatch',
		value: function componentDidCatch(error, errorInfo) {
			var logger = this.props.logger;

			if (logger) {
				// logging error message
				logger.error(errorInfo.componentStack /* information about which component threw the error. */);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			if (this.state.hasError) {
				// TODO: error screen when we encounter error
				return null;
			}
			return this.props.children;
		}
	}], [{
		key: 'getDerivedStateFromError',
		value: function getDerivedStateFromError() /*error*/{
			// Update state so the next render will show the fallback UI.
			return { hasError: true };
		}
	}]);

	return ErrorBoundary;
}(_react.Component);

ErrorBoundary.propTypes = {
	logger: _propTypes2.default.object.isRequired,
	children: _propTypes2.default.any
};

ErrorBoundary.defaultProps = {
	children: []
};
exports.default = ErrorBoundary;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(15);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _OverlayDropZone = __webpack_require__(16);

var _OverlayDropZone2 = _interopRequireDefault(_OverlayDropZone);

__webpack_require__(6);

var _OverlayConfig = __webpack_require__(7);

var _OverlayConfig2 = _interopRequireDefault(_OverlayConfig);

var _mobxStateTree = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var HIDDEN = 'hidden';

/**
 * The Overlay View
 */

var OverlayView = function (_Component) {
	_inherits(OverlayView, _Component);

	function OverlayView() {
		_classCallCheck(this, OverlayView);

		return _possibleConstructorReturn(this, (OverlayView.__proto__ || Object.getPrototypeOf(OverlayView)).apply(this, arguments));
	}

	_createClass(OverlayView, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    overlayModel = _props.overlayModel,
			    overlayParentNode = _props.overlayParentNode;

			if (!overlayModel || !(0, _mobxStateTree.isAlive)(overlayModel)) {
				// unable to render the view if the model is dead
				return null;
			}
			// NOTE: This ensures the OverlayView properly reacts to the model change
			void overlayModel.modelVer;
			var OVERLAY_STATES = overlayModel.OVERLAY_STATE;
			var currentState = overlayModel.overlayState;
			if (currentState) {
				var className = 'overlayView';
				var toShow = true;
				if (currentState === OVERLAY_STATES.HIDE) {
					toShow = false;
				} else if (currentState === OVERLAY_STATES.SMALL) {
					className += ' smallView';
				}
				if (toShow) {
					this._removeHidden(overlayParentNode);
				} else {
					this._setHidden(overlayParentNode);
				}
				var slotsMap = this._buildSlotsMap();
				if (Object.keys(slotsMap).length) {
					return _react2.default.createElement(
						'div',
						{ className: className },
						this._renderContainers(slotsMap)
					);
				}
			}
			return null;
		}
		// Hide the whole dropZoneOverlay element to not interfere with selection in widget

	}, {
		key: '_setHidden',
		value: function _setHidden(node) {
			var classList = node.classList;
			if (classList && !classList.contains(HIDDEN)) {
				classList.add(HIDDEN);
			}
		}
	}, {
		key: '_removeHidden',
		value: function _removeHidden(node) {
			var classList = node.classList;
			if (classList && classList.contains(HIDDEN)) {
				classList.remove(HIDDEN);
			}
		}
	}, {
		key: '_buildSlotsMap',
		value: function _buildSlotsMap() {
			var _this2 = this;

			var visualization = this.props.content.getFeature('Visualization');
			var visType = visualization.getType();
			var slots = visualization.getSlots();
			var slotsList = slots.getSlotList();
			var slotsMap = {};
			slotsList.map(function (slot) {
				var slotId = slot.getDefinition().getId();
				var className = _this2._getDropZonePosition(visType, slotId);
				if (className) {
					slotsMap[className] = slotsMap[className] ? slotsMap[className] : [];
					slotsMap[className].push(slot);
				}
			});
			return slotsMap;
		}
	}, {
		key: '_renderDropZones',
		value: function _renderDropZones(slots) {
			var _this3 = this;

			if (slots) {
				return slots.map(function (slot) {
					var slotId = slot.getDefinition().getId();
					var dndManager = _this3.props.dashboard.getFeature('.DndManager');
					return _react2.default.createElement(_OverlayDropZone2.default, {
						key: slotId,
						slot: slot,
						slotDataItemHandler: _this3.props.overlayModel.getSlotDataItemHandler(slot, -1 /*index in slot*/),
						dashboard: _this3.props.dashboard,
						dndManager: dndManager });
				});
			}
		}
	}, {
		key: '_renderContainers',
		value: function _renderContainers(slotsMap) {
			return _react2.default.createElement(
				'div',
				{ className: 'overlayContainer' },
				this._renderVerticalContainer(slotsMap, 'left'),
				_react2.default.createElement(
					'div',
					{ className: 'overlayContainerMiddle' },
					this._renderHorizontalContainer(slotsMap),
					this._renderHorizontalContainer(slotsMap, 'bottom')
				),
				this._renderVerticalContainer(slotsMap, 'right')
			);
		}
	}, {
		key: '_renderHorizontalContainer',
		value: function _renderHorizontalContainer(slotsMap) {
			var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

			var sectionClassName = 'overlayContainer_' + position;
			if (slotsMap[position + '_single'] || slotsMap[position + '_multiple']) {
				return _react2.default.createElement(
					'div',
					{ className: sectionClassName },
					slotsMap[position + '_multiple'] && _react2.default.createElement(
						'div',
						{ className: 'overlayContainerMultiple' },
						this._renderDropZones(slotsMap[position + '_multiple'])
					),
					slotsMap[position + '_single'] && _react2.default.createElement(
						'div',
						{ className: 'overlayContainerSingle' },
						this._renderDropZones(slotsMap[position + '_single'])
					)
				);
			}
		}
	}, {
		key: '_renderVerticalContainer',
		value: function _renderVerticalContainer(slotsMap) {
			var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'left';

			var sectionClassName = 'section_' + position;
			var className = 'overlayContainer_' + position;
			if (slotsMap[position]) {
				return _react2.default.createElement(
					'div',
					{ className: sectionClassName },
					_react2.default.createElement(
						'div',
						{ className: className },
						this._renderDropZones(slotsMap[position])
					)
				);
			}
		}
	}, {
		key: '_getDropZonePosition',
		value: function _getDropZonePosition(visType, slotId) {
			var SLOTS_ID_POSITION_MAP = _OverlayConfig2.default;
			var dropZonePosition = void 0;
			if (SLOTS_ID_POSITION_MAP[visType]) {
				Object.keys(SLOTS_ID_POSITION_MAP[visType]).forEach(function (position) {
					if (SLOTS_ID_POSITION_MAP[visType][position].includes(slotId)) {
						dropZonePosition = position;
					}
				});
			}
			return dropZonePosition;
		}
	}]);

	return OverlayView;
}(_react.Component);

OverlayView.propTypes = {
	content: _propTypes2.default.object.isRequired,
	dashboard: _propTypes2.default.object.isRequired,
	overlayModel: _propTypes2.default.object.isRequired,
	overlayParentNode: _propTypes2.default.object.isRequired
};

exports.default = (0, _mobxReact.observer)(OverlayView);

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_15__;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(17);

var _StringResources2 = _interopRequireDefault(_StringResources);

__webpack_require__(6);

var _DndSlotItemHandler = __webpack_require__(24);

var _DndSlotItemHandler2 = _interopRequireDefault(_DndSlotItemHandler);

var _caUiToolkit = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var MAX_TAGS_DISPLAYED = 2;

/**
 * The Overlay Drop Zone View
 */

var OverlayDropZone = function (_Component) {
	_inherits(OverlayDropZone, _Component);

	function OverlayDropZone() {
		_classCallCheck(this, OverlayDropZone);

		return _possibleConstructorReturn(this, (OverlayDropZone.__proto__ || Object.getPrototypeOf(OverlayDropZone)).apply(this, arguments));
	}

	_createClass(OverlayDropZone, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this._initializeDndSupport();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.dropSlotItemHandler && this.dropSlotItemHandler.destroy();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var className = 'overlayDropZone';
			if (this.props.className) {
				className += ' ' + this.props.className;
			}
			var items = [];
			if (this.props.slot) {
				items = this.props.slot.getDataItemList();
			}
			var dropZoneCaption = this.props.slot.getDefinition().getCaption();
			var slotId = this.props.slot.getDefinition().getId();
			return _react2.default.createElement(
				'div',
				{ className: className },
				_react2.default.createElement(
					'div',
					{ className: 'overlayDropZoneCaption' },
					this._isRequiredField() ? _react2.default.createElement(
						'span',
						{ className: 'overlayDropZoneCaptionRequiredStar' },
						'*'
					) : null,
					dropZoneCaption
				),
				_react2.default.createElement(
					'div',
					{ className: 'overlayDropZonePlaceHolder', 'data-slot-id': slotId, ref: function ref(node) {
							_this2.domNode = node;
						} },
					this._renderItems(items)
				)
			);
		}
	}, {
		key: '_isRequiredField',
		value: function _isRequiredField() {
			return !this.props.slot.getDefinition().isOptional() && this.props.slot.getDefinition().getShowRequiredMarker();
		}

		//Drag and Drop Support.

	}, {
		key: '_initializeDndSupport',
		value: function _initializeDndSupport() {
			if (this.props.dndManager && this.domNode) {
				var dndManager = this.props.dndManager;
				//Initialize a drop handler for both the item node and the 'after node'.
				//Also initialize the node as a drag source.
				this._dndManager = dndManager;
				this.dropSlotItemHandler = new _DndSlotItemHandler2.default({
					domNode: this.domNode,
					className: 'dndHover',
					slotDataItemHandler: this.props.slotDataItemHandler,
					addAfter: false,
					isVisOverlay: true,
					onDragEnter: this._onDragEnterExecute.bind(this),
					onDragLeave: this._onDragLeaveExecute.bind(this),
					dndManager: dndManager
				});
			}
		}
	}, {
		key: '_onDragEnterExecute',
		value: function _onDragEnterExecute() {
			var dataViewNode = this._getDataViewNode();
			if (dataViewNode) {
				dataViewNode.classList.add('notOnFocus');
			}
		}
	}, {
		key: '_onDragLeaveExecute',
		value: function _onDragLeaveExecute() {
			var dataViewNode = this._getDataViewNode();
			if (dataViewNode) {
				dataViewNode.classList.remove('notOnFocus');
			}
		}
	}, {
		key: '_getDataViewNode',
		value: function _getDataViewNode() {
			if (this.domNode) {
				var _closest = function _closest(el, className) {
					// Traverse the DOM up with a while loop
					while (el.className.indexOf(className) === -1) {
						// Increment the loop to the parent node
						el = el.parentNode;
						if (!el) {
							return null;
						}
					}
					return el;
				};
				var widgetContentNode = _closest(this.domNode, 'liveWidgetContent');
				if (widgetContentNode) {
					var dataViewNode = widgetContentNode.querySelector('.dataview');
					return dataViewNode;
				}
			}
		}
	}, {
		key: '_getSlotDataItemHandler',
		value: function _getSlotDataItemHandler() {
			return this.props.slotDataItemHandler;
		}
	}, {
		key: '_renderItems',
		value: function _renderItems(items) {
			var _this3 = this;

			var content = void 0;
			var tags = [];
			if (items.length) {
				var slotHasUnavailableColumns = this.props.slot.hasUnavailableMetadataColumns();
				var tagLabel = void 0;
				items.forEach(function (item, index) {
					tagLabel = null;
					if (index < MAX_TAGS_DISPLAYED) {
						tagLabel = _this3._getSlotItemLabel(item, slotHasUnavailableColumns);
					} else if (index === MAX_TAGS_DISPLAYED) {
						// If there are more than 3 data items mapped to the slot, display "+N" as the last tag where N is the number of remaining mapped items
						tagLabel = '+' + (items.length - MAX_TAGS_DISPLAYED);
					}
					if (tagLabel) {
						tags.push({
							value: index++,
							label: tagLabel,
							color: 'gray'
						});
					}
				});
				content = _react2.default.createElement(
					'div',
					{ className: 'overlayDropZoneItems' },
					_react2.default.createElement(_caUiToolkit.Tags, {
						id: 'default',
						tags: tags,
						fullWidth: false,
						removable: false,
						maxTagWidth: 90
					}),
					_react2.default.createElement('div', { className: 'overlayDropZoneItemsInsertAfter' })
				);
			} else {
				content = _react2.default.createElement(
					'div',
					{ className: 'overlayDropZonePlaceHolderText' },
					_StringResources2.default.get('overlayDropZonePlaceHolderText')
				);
			}
			return content;
		}
	}, {
		key: '_getSlotItemLabel',
		value: function _getSlotItemLabel(dataItem, slotHasUnavailableColumns) {
			var label = dataItem.getLabel();
			if (slotHasUnavailableColumns) {
				// check if the current data item is the missing one
				var metadataColumn = dataItem.getMetadataColumn();
				if (!metadataColumn) {
					label = _StringResources2.default.get('missingColumn', { 'columnLabel': label });
				}
			}
			return label;
		}
	}]);

	return OverlayDropZone;
}(_react.Component);

OverlayDropZone.propTypes = {
	className: _propTypes2.default.string,
	slot: _propTypes2.default.object.isRequired,
	dndManager: _propTypes2.default.object.isRequired,
	dashboard: _propTypes2.default.object.isRequired,
	slotDataItemHandler: _propTypes2.default.object.isRequired
};
OverlayDropZone.defaultProps = {
	className: ''
};

exports.default = OverlayDropZone;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _VisSlotEditorResources = __webpack_require__(18);

var _VisSlotEditorResources2 = _interopRequireDefault(_VisSlotEditorResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Polyglot = __webpack_require__(19);

var StringResources = function () {
	function StringResources() {
		_classCallCheck(this, StringResources);

		/**
   * Module which provides simple access to string resources.
   */
		this.polyglot = new Polyglot({
			phrases: _VisSlotEditorResources2.default
		});
	}

	/**
  * Get the string resource for the given key and interpolation options
  *
  * @param key						The  key of the string to return
  * @param interpolationOptions		Optional interpolation options (see poly.t documentation for details)
  * @returns							The string to display
  */


	_createClass(StringResources, [{
		key: 'get',
		value: function get(key, interpolationOptions) {
			return this.polyglot.t(key, interpolationOptions);
		}
	}]);

	return StringResources;
}();

exports.default = new StringResources();

/***/ }),
/* 18 */
/***/ (function(module, exports) {

var amdi18n={"__root":{"localFilters":"Local filters","slotEditorMsg1":"Required field","slotEditorMsg2":"Drag and drop data to the fields above to build and filter the visualization.","missingColumn":"Missing: %{columnLabel}","placeholderDropzone":"Click or drag data here","slotEditor_emptyState_no_visualization_selected_title":"No visualization selected","slotEditor_emptyState_no_visualization_selected_description":"Select a visualization to manage the field settings.","slotEditor_emptyState_widget_not_support_slot_selected_title":"The widget selected does not use fields","slotEditor_emptyState_widget_not_support_slot_selected_description":"Select a visualization to manage the field settings.","slotEditor_emptyState_multiple_visualizations_selected_title":"Multiple widgets selected","slotEditor_emptyState_multiple_visualizations_selected_description":"Select a visualization to manage the field settings.","slotEditor_emptyState_visualization_has_error_title":"The visualization cannot be displayed","slotEditor_slotItem_tooltip":"Source:","slotEditor_emptyState_vis_not_created_title":"No visualization created","slotEditor_emptyState_vis_not_created_description":"Create a visualization to manage the field settings.","slotEditor":"Fields","slotEditorCoachMarkTitle":"Access fields","slotEditorCoachMarkContents":"Add columns to the fields to build and modify visualizations.","toolbarDeleteFilterActionText":"Remove filter","toolbarActionFilter":"Filter","filterAutobinActionText":"Filter bins","coachMarkTitleSpiralTarget":"Edit scope","coachMarkContentSpiralTarget":"This is where you can access and modify the driver selection for your target.","overlayDropZonePlaceHolderText":"Drag data here"},"__cs":{"localFilters":"Lokální filtry","slotEditorMsg1":"Povinné pole","slotEditorMsg2":"Přetáhněte data do polí nahoře, aby se sestavila a filtrovala vizualizace.","missingColumn":"Chybí: %{columnLabel}","placeholderDropzone":"Klepněte nebo přetáhněte data sem","slotEditor_emptyState_no_visualization_selected_title":"Není vybrána žádná vizualizace","slotEditor_emptyState_no_visualization_selected_description":"Vyberte vizualizaci pro správu nastavení polí.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Vybraný modul widget nepoužívá pole","slotEditor_emptyState_widget_not_support_slot_selected_description":"Vyberte vizualizaci pro správu nastavení polí.","slotEditor_emptyState_multiple_visualizations_selected_title":"Vybráno více modulů widget","slotEditor_emptyState_multiple_visualizations_selected_description":"Vyberte vizualizaci pro správu nastavení polí.","slotEditor_emptyState_visualization_has_error_title":"Vizualizaci nelze zobrazit","slotEditor_slotItem_tooltip":"Zdroj:","slotEditor_emptyState_vis_not_created_title":"Nebyla vytvořena žádná vizualizace","slotEditor_emptyState_vis_not_created_description":"Vytvořte vizualizaci pro správu nastavení polí.","slotEditor":"Pole","slotEditorCoachMarkTitle":"Přístupová pole","slotEditorCoachMarkContents":"Přidejte sloupce do polí, abyste mohli sestavovat a upravovat vizualizace.","toolbarDeleteFilterActionText":"Odebrat filtr","toolbarActionFilter":"Filtr","filterAutobinActionText":"Filtrovat přihrádky","coachMarkTitleSpiralTarget":"Upravit rozsah","coachMarkContentSpiralTarget":"Zde je k dispozici přístup k výběru drivery pro cíl a možnost jeho úprav.","overlayDropZonePlaceHolderText":"Přetáhněte data sem"},"__da":{"localFilters":"Lokale filtre","slotEditorMsg1":"Påkrævet felt","slotEditorMsg2":"Træk og placér data til felterne ovenfor for at bygge og filtrere visualiseringen.","missingColumn":"Mangler: %{columnLabel}","placeholderDropzone":"Klik og træk data her","slotEditor_emptyState_no_visualization_selected_title":"Der er ikke valgt nogen visualisering","slotEditor_emptyState_no_visualization_selected_description":"Vælg en visualisering for at administrere feltindstilingerne.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Den valgte widget bruger ikke felter","slotEditor_emptyState_widget_not_support_slot_selected_description":"Vælg en visualisering for at administrere feltindstilingerne.","slotEditor_emptyState_multiple_visualizations_selected_title":"Flere widgetter er valgt","slotEditor_emptyState_multiple_visualizations_selected_description":"Vælg en visualisering for at administrere feltindstilingerne.","slotEditor_emptyState_visualization_has_error_title":"Visualiseringen kan ikke vises","slotEditor_slotItem_tooltip":"Kilde:","slotEditor_emptyState_vis_not_created_title":"Ingen visualisering er oprettet","slotEditor_emptyState_vis_not_created_description":"Opret en visualisering for at administrere feltindstilingerne.","slotEditor":"Felter","slotEditorCoachMarkTitle":"Anvend felter","slotEditorCoachMarkContents":"Tilføj kolonner til felterne for at bygge og ændre visualiseringer.","toolbarDeleteFilterActionText":"Fjern filter","toolbarActionFilter":"Filtrér","filterAutobinActionText":"Filtrér områder (bins)","coachMarkTitleSpiralTarget":"Redigér omfang","coachMarkContentSpiralTarget":"Her kan du få adgang til og ændre styreprogramvalget for dit mål.","overlayDropZonePlaceHolderText":"Træk data her"},"__de":{"localFilters":"Lokale Filter","slotEditorMsg1":"Erforderliches Feld","slotEditorMsg2":"Daten in die Felder oben ziehen und ablegen, um die Visualisierung zu erstellen und zu filtern.","missingColumn":"Nicht vorhanden: %{columnLabel}","placeholderDropzone":"Klicken oder Daten hierher ziehen","slotEditor_emptyState_no_visualization_selected_title":"Keine Visualisierung ausgewählt","slotEditor_emptyState_no_visualization_selected_description":"Zum Verwalten der Feldeigenschaften eine Visualisierung auswählen.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Ausgewähltes Widget verwendet keine Felder","slotEditor_emptyState_widget_not_support_slot_selected_description":"Zum Verwalten der Feldeigenschaften eine Visualisierung auswählen.","slotEditor_emptyState_multiple_visualizations_selected_title":"Mehrere Widgets ausgewählt","slotEditor_emptyState_multiple_visualizations_selected_description":"Zum Verwalten der Feldeigenschaften eine Visualisierung auswählen.","slotEditor_emptyState_visualization_has_error_title":"Anzeigen der Visualisierung nicht möglich","slotEditor_slotItem_tooltip":"Quelle:","slotEditor_emptyState_vis_not_created_title":"Keine Visualisierung erstellt","slotEditor_emptyState_vis_not_created_description":"Zum Verwalten der Feldeigenschaften eine Visualisierung erstellen.","slotEditor":"Felder","slotEditorCoachMarkTitle":"Felder aufrufen","slotEditorCoachMarkContents":"Spalten zu den Feldern hinzufügen, um Visualisierungen zu erstellen und zu ändern.","toolbarDeleteFilterActionText":"Filter entfernen","toolbarActionFilter":"Filtern","filterAutobinActionText":"Bins filtern","coachMarkTitleSpiralTarget":"Bereich bearbeiten","coachMarkContentSpiralTarget":"Hier können Sie auf die Auswahl der Einflussfaktoren für das Ziel zugreifen und gegebenenfalls Änderungen vornehmen.","overlayDropZonePlaceHolderText":"Daten hierher ziehen"},"__es":{"localFilters":"Filtros locales","slotEditorMsg1":"Campo necesario","slotEditorMsg2":"Arrastre y suelte los datos en los campos para crear y filtrar la visualización.","missingColumn":"Falta: %{columnLabel}","placeholderDropzone":"Pulse o arrastre los datos aquí ","slotEditor_emptyState_no_visualization_selected_title":"No se ha seleccionado ninguna visualización","slotEditor_emptyState_no_visualization_selected_description":"Seleccione una visualización para gestionar los valores de campos.","slotEditor_emptyState_widget_not_support_slot_selected_title":"El widget seleccionado no utiliza campos","slotEditor_emptyState_widget_not_support_slot_selected_description":"Seleccione una visualización para gestionar los valores de campos.","slotEditor_emptyState_multiple_visualizations_selected_title":"Varios widgets seleccionados","slotEditor_emptyState_multiple_visualizations_selected_description":"Seleccione una visualización para gestionar los valores de campos.","slotEditor_emptyState_visualization_has_error_title":"La visualización no se puede visualizar","slotEditor_slotItem_tooltip":"Origen:","slotEditor_emptyState_vis_not_created_title":"No se ha creado ninguna visualización","slotEditor_emptyState_vis_not_created_description":"Cree una visualización para gestionar los valores de campos.","slotEditor":"Campos","slotEditorCoachMarkTitle":"Acceder a campos","slotEditorCoachMarkContents":"Añada columnas a los campos para crear y modificar visualizaciones.","toolbarDeleteFilterActionText":"Eliminar filtro","toolbarActionFilter":"Filtro","filterAutobinActionText":"Filtrar cubetas","coachMarkTitleSpiralTarget":"Editar ámbito","coachMarkContentSpiralTarget":"Aquí puede acceder y modificar la selección de controlador de su destino.","overlayDropZonePlaceHolderText":"Arrastre los datos aquí "},"__fi":{"localFilters":"Paikalliset suodattimet","slotEditorMsg1":"Pakollinen kenttä","slotEditorMsg2":"Voit muodostaa visualisoinnin ja suodattaa sen vetämällä ja pudottamalla tiedot yllä oleviin kenttiin.","missingColumn":"Puuttuva: %{columnLabel}","placeholderDropzone":"Napsauta tätä, tai vedä tiedot tähän","slotEditor_emptyState_no_visualization_selected_title":"Visualisointia ei ole valittu","slotEditor_emptyState_no_visualization_selected_description":"Valitse visualisointi, jotta voit hallita kentän asetuksia.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Valittu pienoisohjelma ei käytä kenttiä","slotEditor_emptyState_widget_not_support_slot_selected_description":"Valitse visualisointi, jotta voit hallita kentän asetuksia.","slotEditor_emptyState_multiple_visualizations_selected_title":"On valittu useita pienoisohjelmia","slotEditor_emptyState_multiple_visualizations_selected_description":"Valitse visualisointi, jotta voit hallita kentän asetuksia.","slotEditor_emptyState_visualization_has_error_title":"Visualisoinnin näyttö ei onnistunut","slotEditor_slotItem_tooltip":"Lähde:","slotEditor_emptyState_vis_not_created_title":"Visualisointia ei ole luotu","slotEditor_emptyState_vis_not_created_description":"Valitse visualisointi, jotta voit hallita kentän asetuksia.","slotEditor":"Kentät","slotEditorCoachMarkTitle":"Kenttien käyttö","slotEditorCoachMarkContents":"Lisää kenttiin sarakkeita visualisointien luontia ja muokkausta varten.","toolbarDeleteFilterActionText":"Poista suodatin","toolbarActionFilter":"Suodatin","filterAutobinActionText":"Suodata numeroryhmät","coachMarkTitleSpiralTarget":"Muokkaa aluetta","coachMarkContentSpiralTarget":"Tässä voit käyttää ja muokata vaikuttimien valintaa kohdetta varten.","overlayDropZonePlaceHolderText":"Vedä tiedot tähän"},"__fr":{"localFilters":"Filtres locaux","slotEditorMsg1":"Zone requise","slotEditorMsg2":"Glissez-déposez des données sur les zones ci-dessus pour générer et filtrer la visualisation.","missingColumn":"Manquant : %{columnLabel}","placeholderDropzone":"Cliquez ou faites glisser les données ici","slotEditor_emptyState_no_visualization_selected_title":"Aucune visualisation sélectionnée","slotEditor_emptyState_no_visualization_selected_description":"Sélectionnez une visualisation pour gérer les paramètres de zone.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Le widget sélectionné n'utilise pas les zones","slotEditor_emptyState_widget_not_support_slot_selected_description":"Sélectionnez une visualisation pour gérer les paramètres de zone.","slotEditor_emptyState_multiple_visualizations_selected_title":"Plusieurs widgets sélectionnés","slotEditor_emptyState_multiple_visualizations_selected_description":"Sélectionnez une visualisation pour gérer les paramètres de zone.","slotEditor_emptyState_visualization_has_error_title":"Impossible d'afficher la visualisation","slotEditor_slotItem_tooltip":"Source :","slotEditor_emptyState_vis_not_created_title":"Aucune visualisation créée","slotEditor_emptyState_vis_not_created_description":"Créez une visualisation pour gérer les paramètres de zone.","slotEditor":"Zones","slotEditorCoachMarkTitle":"Zones d'accès","slotEditorCoachMarkContents":"Ajouter des colonnes aux zones pour générer et modifier des visualisations.","toolbarDeleteFilterActionText":"Retirer le filtre","toolbarActionFilter":"Filtre","filterAutobinActionText":"Filtrer les casiers","coachMarkTitleSpiralTarget":"Editer la portée","coachMarkContentSpiralTarget":"Vous pouvez accéder ici au pilote sélectionné pour votre cible et le modifier.","overlayDropZonePlaceHolderText":"Glisser les données ici"},"__hr":{"localFilters":"Lokalni filteri","slotEditorMsg1":"Obavezno polje","slotEditorMsg2":"Povucite i ispustite podatke gore na polja da izgradite i filtrirate vizualizaciju.","missingColumn":"Nedostaje: %{columnLabel}","placeholderDropzone":"Kliknite ili povucite podatke ovdje","slotEditor_emptyState_no_visualization_selected_title":"Nema izabranih vizualizacija","slotEditor_emptyState_no_visualization_selected_description":"Izaberite vizualizaciju za upravljanje postavkama polja.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Izabrani grafički element ne koristi polja.","slotEditor_emptyState_widget_not_support_slot_selected_description":"Izaberite vizualizaciju za upravljanje postavkama polja.","slotEditor_emptyState_multiple_visualizations_selected_title":"Izabrano je više grafičkih elemenata.","slotEditor_emptyState_multiple_visualizations_selected_description":"Izaberite vizualizaciju za upravljanje postavkama polja.","slotEditor_emptyState_visualization_has_error_title":"Vizualizacija se ne može prikazati.","slotEditor_slotItem_tooltip":"Izvor:","slotEditor_emptyState_vis_not_created_title":"Vizualizacija nije kreirana","slotEditor_emptyState_vis_not_created_description":"Kreirajte vizualizaciju za upravljanje postavkama polja.","slotEditor":"Polja","slotEditorCoachMarkTitle":"Dohvati polja","slotEditorCoachMarkContents":"Poljima dodajte stupce za izgradite i promijenite vizualizacije.","toolbarDeleteFilterActionText":"Ukloni filter","toolbarActionFilter":"Filter","filterAutobinActionText":"Pregradci filtera","coachMarkTitleSpiralTarget":"Uređivanje opsega","coachMarkContentSpiralTarget":"Ovdje možete dohvatiti i promijeniti izbor pogonitelja za vaš cilj.","overlayDropZonePlaceHolderText":"Povucite podatke ovdje"},"__hu":{"localFilters":"Helyi szűrők","slotEditorMsg1":"Kötelező mező","slotEditorMsg2":"Húzza az adatokat a fenti mezőkre a megjelenítés összeállításához és szűréséhez.","missingColumn":"A következő hiányzik: %{columnLabel}","placeholderDropzone":"Kattintson vagy húzzon ide adatokat","slotEditor_emptyState_no_visualization_selected_title":"Nincs kijelölt megjelenítés","slotEditor_emptyState_no_visualization_selected_description":"A mezőbeállítások kezeléséhez válasszon ki egy megjelenítést.","slotEditor_emptyState_widget_not_support_slot_selected_title":"A kiválasztott felületi elem nem használ mezőket","slotEditor_emptyState_widget_not_support_slot_selected_description":"A mezőbeállítások kezeléséhez válasszon ki egy megjelenítést.","slotEditor_emptyState_multiple_visualizations_selected_title":"Több felületi elem lett kiválasztva","slotEditor_emptyState_multiple_visualizations_selected_description":"A mezőbeállítások kezeléséhez válasszon ki egy megjelenítést.","slotEditor_emptyState_visualization_has_error_title":"A megjelenítés nem jeleníthető meg","slotEditor_slotItem_tooltip":"Forrás:","slotEditor_emptyState_vis_not_created_title":"Nincs létrehozva megjelenítés","slotEditor_emptyState_vis_not_created_description":"A mezőbeállítások kezeléséhez hozzon létre egy megjelenítést.","slotEditor":"Mezők","slotEditorCoachMarkTitle":"Mezők elérése","slotEditorCoachMarkContents":"Megjelenítések összeállításához és módosításához vegyen fel oszlopokat a mezőkbe.","toolbarDeleteFilterActionText":"Szűrő eltávolítása","toolbarActionFilter":"Szűrő","filterAutobinActionText":"Tároló szűrése","coachMarkTitleSpiralTarget":"Hatókör szerkesztése","coachMarkContentSpiralTarget":"Itt érheti el és módosíthatja a célhoz kijelölt tényezőket.","overlayDropZonePlaceHolderText":"Húzza ide az adatokat"},"__it":{"localFilters":"Filtri locali","slotEditorMsg1":"Campo obbligatorio","slotEditorMsg2":"Trascinare e rilasciare i dati nei campi sopra riportati per creare e filtrare la visualizzazione.","missingColumn":"Mancante: %{columnLabel}","placeholderDropzone":"Fare clic o trascinare i dati qui ","slotEditor_emptyState_no_visualization_selected_title":"Nessuna visualizzazione selezionata","slotEditor_emptyState_no_visualization_selected_description":"Selezionare una visualizzazione per gestire le impostazioni del campo.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Il widget selezionato non utilizza i campi","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selezionare una visualizzazione per gestire le impostazioni del campo.","slotEditor_emptyState_multiple_visualizations_selected_title":"Più widget selezionati","slotEditor_emptyState_multiple_visualizations_selected_description":"Selezionare una visualizzazione per gestire le impostazioni del campo.","slotEditor_emptyState_visualization_has_error_title":"Impossibile mostrare la visualizzazione","slotEditor_slotItem_tooltip":"Sorgente:","slotEditor_emptyState_vis_not_created_title":"Nessuna visualizzazione creata","slotEditor_emptyState_vis_not_created_description":"Creare una visualizzazione per gestire le impostazioni del campo.","slotEditor":"Campi","slotEditorCoachMarkTitle":"Accedi campi","slotEditorCoachMarkContents":"Aggiungi colonne ai campi per creare e modificare le visualizzazioni.","toolbarDeleteFilterActionText":"Rimuovi filtro","toolbarActionFilter":"Filtra","filterAutobinActionText":"Filtra bin","coachMarkTitleSpiralTarget":"Modifica ambito","coachMarkContentSpiralTarget":"Da qui è possibile accedere e modificare la selezione del driver per la propria destinazione.","overlayDropZonePlaceHolderText":"Trascinare i dati in questo punto"},"__ja":{"localFilters":"ローカル・フィルター","slotEditorMsg1":"必須フィールド","slotEditorMsg2":"上のフィールドにデータをドラッグ・アンド・ドロップし、視覚化を作成してフィルターに掛けます。","missingColumn":"欠落しています: %{columnLabel}","placeholderDropzone":"データをクリックするかここにドラッグしてください","slotEditor_emptyState_no_visualization_selected_title":"視覚化が選択されていません","slotEditor_emptyState_no_visualization_selected_description":"フィールド設定を管理するための視覚化を選択してください。","slotEditor_emptyState_widget_not_support_slot_selected_title":"選択したウィジェットではフィールドは使用しません","slotEditor_emptyState_widget_not_support_slot_selected_description":"フィールド設定を管理するための視覚化を選択してください。","slotEditor_emptyState_multiple_visualizations_selected_title":"複数のウィジェットが選択されています","slotEditor_emptyState_multiple_visualizations_selected_description":"フィールド設定を管理するための視覚化を選択してください。","slotEditor_emptyState_visualization_has_error_title":"視覚化を表示できません","slotEditor_slotItem_tooltip":"ソース:","slotEditor_emptyState_vis_not_created_title":"視覚化が作成されていません","slotEditor_emptyState_vis_not_created_description":"フィールド設定を管理するための視覚化を作成してください。","slotEditor":"フィールド","slotEditorCoachMarkTitle":"フィールドへのアクセス","slotEditorCoachMarkContents":"視覚化を作成したり変更したりするために列をフィールドに追加します。","toolbarDeleteFilterActionText":"フィルターの削除","toolbarActionFilter":"フィルター","filterAutobinActionText":"ビンのフィルター","coachMarkTitleSpiralTarget":"範囲の編集","coachMarkContentSpiralTarget":"ここでターゲットのドライバー選択にアクセスして変更することができます。","overlayDropZonePlaceHolderText":"ここにデータをドラッグ"},"__kk":{"localFilters":"Жергілікті сүзгілер","slotEditorMsg1":"Қажетті өріс","slotEditorMsg2":"Көрнекілікті сүзгілеу және құру үшін өрістерге деректерді сүйреп апарып тастаңыз.","missingColumn":"Жоқ: %{columnLabel}","placeholderDropzone":"Деректерді мына жерге нұқыңыз немесе сүйреңіз","slotEditor_emptyState_no_visualization_selected_title":"Көрнекілендіру таңдалмаған","slotEditor_emptyState_no_visualization_selected_description":"Өрістердің параметрлерін басқару үшін көрнекілендіру жасаңыз.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Таңдалған виджет өрістерды пайдаланбайды","slotEditor_emptyState_widget_not_support_slot_selected_description":"Өрістердің параметрлерін басқару үшін көрнекілендіру таңдаңыз.","slotEditor_emptyState_multiple_visualizations_selected_title":"Бірнеше виджеттер таңдалды","slotEditor_emptyState_multiple_visualizations_selected_description":"Өрістердің параметрлерін басқару үшін көрнекілендіру тандаңыз.","slotEditor_emptyState_visualization_has_error_title":"Көрнекілендіруді көрсету мүмкін емес","slotEditor_slotItem_tooltip":"Бастапқы:","slotEditor_emptyState_vis_not_created_title":"Жасалған көрнекілендіру жоқ","slotEditor_emptyState_vis_not_created_description":"Өрістердің параметрлерін басқару үшін көрнекілендіру жасаңыз.","slotEditor":"Өрістер","slotEditorCoachMarkTitle":"Кіру өрістері","slotEditorCoachMarkContents":"Көрнекілендіру бейнелерді құру және өзгерту үшін өрістерге баған қосыңыз.","toolbarDeleteFilterActionText":"Сүзгіш жою","toolbarActionFilter":"Сүзгі","filterAutobinActionText":"Bin -дерді сүзгілеу","coachMarkTitleSpiralTarget":"Ауқымды өңдеу","coachMarkContentSpiralTarget":"Мұнда мақсатыңызға арналған драйвер таңдауына кіруге және оны өзгертуге болады.","overlayDropZonePlaceHolderText":"Деректерді осы жерге апарыңыз"},"__ko":{"localFilters":"로컬 필터","slotEditorMsg1":"필수 필드","slotEditorMsg2":"시각화를 빌드하고 필터링하려면 위의 필드에 데이터를 끌어서 놓으십시오.","missingColumn":"누락: %{columnLabel}","placeholderDropzone":"데이터 클릭 또는 여기로 끌기","slotEditor_emptyState_no_visualization_selected_title":"선택된 시각화 없음","slotEditor_emptyState_no_visualization_selected_description":"필드 설정을 관리하려면 시각화를 선택하십시오.","slotEditor_emptyState_widget_not_support_slot_selected_title":"선택한 위젯에서 필드를 사용하지 않음","slotEditor_emptyState_widget_not_support_slot_selected_description":"필드 설정을 관리하려면 시각화를 선택하십시오.","slotEditor_emptyState_multiple_visualizations_selected_title":"여러 위젯이 선택됨","slotEditor_emptyState_multiple_visualizations_selected_description":"필드 설정을 관리하려면 시각화를 선택하십시오.","slotEditor_emptyState_visualization_has_error_title":"시각화를 표시할 수 없음","slotEditor_slotItem_tooltip":"소스:","slotEditor_emptyState_vis_not_created_title":"작성된 시각화 없음","slotEditor_emptyState_vis_not_created_description":"필드 설정을 관리하려면 시각화를 작성하십시오.","slotEditor":"필드","slotEditorCoachMarkTitle":"액세스 필드","slotEditorCoachMarkContents":"시각화를 빌드하고 수정하려면 필드에 열을 추가하십시오.","toolbarDeleteFilterActionText":"필터 제거","toolbarActionFilter":"필터","filterAutobinActionText":"구간 필터","coachMarkTitleSpiralTarget":"범위 편집","coachMarkContentSpiralTarget":"대상에 대한 드라이버 선택에 액세스하고 수정할 수 있는 위치입니다.","overlayDropZonePlaceHolderText":"데이터 여기에 놓기"},"__nb":{"localFilters":"Lokale filtre","slotEditorMsg1":"Obligatorisk felt","slotEditorMsg2":"Dra og slipp data i feltene ovenfor for å bygge og filtrere visualiseringen.","missingColumn":"Mangler: %{columnLabel}","placeholderDropzone":"Klikk eller dra data hit","slotEditor_emptyState_no_visualization_selected_title":"Ingen visualisering valgt","slotEditor_emptyState_no_visualization_selected_description":"Velg en visualisering for å administrere innstillingene for felt.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Den valgte widgeten bruker ikke felt","slotEditor_emptyState_widget_not_support_slot_selected_description":"Velg en visualisering for å administrere innstillingene for felt.","slotEditor_emptyState_multiple_visualizations_selected_title":"Flere widgeter valgt","slotEditor_emptyState_multiple_visualizations_selected_description":"Velg en visualisering for å administrere innstillingene for felt.","slotEditor_emptyState_visualization_has_error_title":"Visualiseringen kan ikke vises","slotEditor_slotItem_tooltip":"Kilde:","slotEditor_emptyState_vis_not_created_title":"Ingen visualisering opprettet","slotEditor_emptyState_vis_not_created_description":"Opprett en visualisering for å administrere innstillingene for felt.","slotEditor":"Felt","slotEditorCoachMarkTitle":"Tilgang til felt","slotEditorCoachMarkContents":"Legg til kolonner i feltene for å bygge og endre visualiseringer.","toolbarDeleteFilterActionText":"Fjern filter","toolbarActionFilter":"Filtrer","filterAutobinActionText":"Filtrer binger","coachMarkTitleSpiralTarget":"Rediger omfang","coachMarkContentSpiralTarget":"Her får du tilgang til og kan endre drivervalget for målet ditt.","overlayDropZonePlaceHolderText":"Dra data hit"},"__nl":{"localFilters":"Lokale filters","slotEditorMsg1":"Verplicht veld","slotEditorMsg2":"Versleep de gegevens naar de bovenstaande velden om de visualisatie samen te stellen en te filteren.","missingColumn":"%{columnLabel} ontbreekt","placeholderDropzone":"Klik hier of versleep gegevens hiernaartoe","slotEditor_emptyState_no_visualization_selected_title":"Geen visualisatie geselecteerd","slotEditor_emptyState_no_visualization_selected_description":"Selecteer een visualisatie om de instellingen van het veld te beheren.","slotEditor_emptyState_widget_not_support_slot_selected_title":"De geselecteerde widget gebruikt geen velden","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selecteer een visualisatie om de instellingen van het veld te beheren.","slotEditor_emptyState_multiple_visualizations_selected_title":"Meerdere widgets geselecteerd","slotEditor_emptyState_multiple_visualizations_selected_description":"Selecteer een visualisatie om de instellingen van het veld te beheren.","slotEditor_emptyState_visualization_has_error_title":"De visualisatie kan niet worden afgebeeld","slotEditor_slotItem_tooltip":"Bron:","slotEditor_emptyState_vis_not_created_title":"Geen visualisatie gemaakt","slotEditor_emptyState_vis_not_created_description":"Maak een visualisatie om de instellingen van het veld te beheren.","slotEditor":"Velden","slotEditorCoachMarkTitle":"Velden benaderen","slotEditorCoachMarkContents":"Voeg kolommen toe aan de velden om visualisaties te bouwen en te wijzigen.","toolbarDeleteFilterActionText":"Filter verwijderen","toolbarActionFilter":"Filteren","filterAutobinActionText":"Bins filteren","coachMarkTitleSpiralTarget":"Bereik bewerken","coachMarkContentSpiralTarget":"Dit is de plek waar u toegang hebt tot de driverselectie voor uw doel en waar u wijzigingen kunt aanbrengen.","overlayDropZonePlaceHolderText":"Sleep gegevens hier naartoe"},"__no":{"localFilters":"Lokale filtre","slotEditorMsg1":"Obligatorisk felt","slotEditorMsg2":"Dra og slipp data i feltene ovenfor for å bygge og filtrere visualiseringen.","missingColumn":"Mangler: %{columnLabel}","placeholderDropzone":"Klikk eller dra data hit","slotEditor_emptyState_no_visualization_selected_title":"Ingen visualisering valgt","slotEditor_emptyState_no_visualization_selected_description":"Velg en visualisering for å administrere innstillingene for felt.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Den valgte widgeten bruker ikke felt","slotEditor_emptyState_widget_not_support_slot_selected_description":"Velg en visualisering for å administrere innstillingene for felt.","slotEditor_emptyState_multiple_visualizations_selected_title":"Flere widgeter valgt","slotEditor_emptyState_multiple_visualizations_selected_description":"Velg en visualisering for å administrere innstillingene for felt.","slotEditor_emptyState_visualization_has_error_title":"Visualiseringen kan ikke vises","slotEditor_slotItem_tooltip":"Kilde:","slotEditor_emptyState_vis_not_created_title":"Ingen visualisering opprettet","slotEditor_emptyState_vis_not_created_description":"Opprett en visualisering for å administrere innstillingene for felt.","slotEditor":"Felt","slotEditorCoachMarkTitle":"Tilgang til felt","slotEditorCoachMarkContents":"Legg til kolonner i feltene for å bygge og endre visualiseringer.","toolbarDeleteFilterActionText":"Fjern filter","toolbarActionFilter":"Filtrer","filterAutobinActionText":"Filtrer binger","coachMarkTitleSpiralTarget":"Rediger omfang","coachMarkContentSpiralTarget":"Her får du tilgang til og kan endre drivervalget for målet ditt.","overlayDropZonePlaceHolderText":"Dra data hit"},"__pl":{"localFilters":"Filtry lokalne","slotEditorMsg1":"Pole wymagane","slotEditorMsg2":"Przeciągnij i upuść dane w powyższych szczelinach, aby utworzyć i przefiltrować wizualizację.","missingColumn":"Brak: %{columnLabel}","placeholderDropzone":"Kliknij lub przeciągnij dane w to miejsce","slotEditor_emptyState_no_visualization_selected_title":"Nie wybrano wizualizacji","slotEditor_emptyState_no_visualization_selected_description":"Wybierz wizualizację, aby zarządzać ustawieniami pól.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Wybrany widget nie korzysta ze pól","slotEditor_emptyState_widget_not_support_slot_selected_description":"Wybierz wizualizację, aby zarządzać ustawieniami pól.","slotEditor_emptyState_multiple_visualizations_selected_title":"Wybrano więcej niż jeden widget","slotEditor_emptyState_multiple_visualizations_selected_description":"Wybierz wizualizację, aby zarządzać ustawieniami pól.","slotEditor_emptyState_visualization_has_error_title":"Nie można wyświetlić wizualizacji","slotEditor_slotItem_tooltip":"Źródło:","slotEditor_emptyState_vis_not_created_title":"Nie utworzono żadnej wizualizacji","slotEditor_emptyState_vis_not_created_description":"Utwórz wizualizację, aby zarządzać ustawieniami pól.","slotEditor":"Pola","slotEditorCoachMarkTitle":"Uzyskaj dostęp do pól","slotEditorCoachMarkContents":"Dodawaj kolumny do pól, aby budować i modyfikować wizualizacje.","toolbarDeleteFilterActionText":"Usuń filtr","toolbarActionFilter":"Filtr","filterAutobinActionText":"Filtruj kategorie","coachMarkTitleSpiralTarget":"Edytuj zakres","coachMarkContentSpiralTarget":"W tym miejscu można uzyskać dostęp do czynników dla zmiennej przewidywanej i zmodyfikować ich wybór.","overlayDropZonePlaceHolderText":"Przeciągnij tutaj dane"},"__pt":{"localFilters":"Filtros locais","slotEditorMsg1":"Campo requerido","slotEditorMsg2":"Arraste e solte dados para os campos acima para criar e filtrar a visualização.","missingColumn":"Ausente: %{columnLabel}","placeholderDropzone":"Clicar ou arrastar dados aqui","slotEditor_emptyState_no_visualization_selected_title":"Nenhuma visualização selecionada","slotEditor_emptyState_no_visualization_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_widget_not_support_slot_selected_title":"O widget selecionado não usa campos","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_multiple_visualizations_selected_title":"Vários widgets selecionados","slotEditor_emptyState_multiple_visualizations_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_visualization_has_error_title":"Não é possível exibir a visualização","slotEditor_slotItem_tooltip":"Origem:","slotEditor_emptyState_vis_not_created_title":"Nenhuma visualização criada","slotEditor_emptyState_vis_not_created_description":"Crie uma visualização para gerenciar as configurações de campo.","slotEditor":"Campos","slotEditorCoachMarkTitle":"Campos de acesso","slotEditorCoachMarkContents":"Inclua colunas nos campos para criar e modificar visualizações.","toolbarDeleteFilterActionText":"Remover filtro","toolbarActionFilter":"Filtrar","filterAutobinActionText":"Filtro de categorias","coachMarkTitleSpiralTarget":"Editar escopo","coachMarkContentSpiralTarget":"Este é o local onde é possível acessar e modificar a seleção do driver para seu destino.","overlayDropZonePlaceHolderText":"Arraste os dados para cá"},"__pt-br":{"localFilters":"Filtros locais","slotEditorMsg1":"Campo requerido","slotEditorMsg2":"Arraste e solte dados para os campos acima para criar e filtrar a visualização.","missingColumn":"Ausente: %{columnLabel}","placeholderDropzone":"Clicar ou arrastar dados aqui","slotEditor_emptyState_no_visualization_selected_title":"Nenhuma visualização selecionada","slotEditor_emptyState_no_visualization_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_widget_not_support_slot_selected_title":"O widget selecionado não usa campos","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_multiple_visualizations_selected_title":"Vários widgets selecionados","slotEditor_emptyState_multiple_visualizations_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_visualization_has_error_title":"Não é possível exibir a visualização","slotEditor_slotItem_tooltip":"Origem:","slotEditor_emptyState_vis_not_created_title":"Nenhuma visualização criada","slotEditor_emptyState_vis_not_created_description":"Crie uma visualização para gerenciar as configurações de campo.","slotEditor":"Campos","slotEditorCoachMarkTitle":"Campos de acesso","slotEditorCoachMarkContents":"Inclua colunas nos campos para criar e modificar visualizações.","toolbarDeleteFilterActionText":"Remover filtro","toolbarActionFilter":"Filtrar","filterAutobinActionText":"Filtro de categorias","coachMarkTitleSpiralTarget":"Editar escopo","coachMarkContentSpiralTarget":"Este é o local onde é possível acessar e modificar a seleção do driver para seu destino.","overlayDropZonePlaceHolderText":"Arraste os dados para cá"},"__ro":{"localFilters":"Filtre locale","slotEditorMsg1":"Câmp necesar","slotEditorMsg2":"Trageţi şi plasaţi datele în câmpurile de deasupra, pentru a construi şi filtra vizualizarea.","missingColumn":"Lipsă: %{columnLabel}","placeholderDropzone":"Faceţi clic sau trageţi date aici ","slotEditor_emptyState_no_visualization_selected_title":"Nicio vizualizare selectată","slotEditor_emptyState_no_visualization_selected_description":"Selectaţi o vizualizare pentru gestionarea setărilor de câmp.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Widget-ul selectat nu utilizează câmpuri.","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selectaţi o vizualizare pentru gestionarea setărilor de câmp.","slotEditor_emptyState_multiple_visualizations_selected_title":"Sunt selectate mai multe widget-uri","slotEditor_emptyState_multiple_visualizations_selected_description":"Selectaţi o vizualizare pentru gestionarea setărilor de câmp.","slotEditor_emptyState_visualization_has_error_title":"Vizualizarea nu poate fi afişată.","slotEditor_slotItem_tooltip":"Sursă:","slotEditor_emptyState_vis_not_created_title":"Nu a fost creată nicio vizualizare","slotEditor_emptyState_vis_not_created_description":"Creaţi o vizualizare pentru gestionarea setărilor de câmp.","slotEditor":"Câmpuri","slotEditorCoachMarkTitle":"Accesare câmpuri","slotEditorCoachMarkContents":"Adăugaţi coloane la câmpuri pentru a construi şi modifica vizualizările.","toolbarDeleteFilterActionText":"Înlăturare filtru","toolbarActionFilter":"Filtru","filterAutobinActionText":"Filtrare bin-uri","coachMarkTitleSpiralTarget":"Editare domeniu","coachMarkContentSpiralTarget":"Aici puteţi accesa şi modifica selecţia de driver-e pentru ţinta dumneavoastră.","overlayDropZonePlaceHolderText":"Trageţi date aici"},"__ru":{"localFilters":"Локальные фильтры","slotEditorMsg1":"Обязательное поле","slotEditorMsg2":"Перетащите данные на находящиеся выше поля, чтобы построить визуализацию и применить к ней фильтр.","missingColumn":"Отсутствует: %{columnLabel}","placeholderDropzone":"Щелкните здесь или перетащите сюда данные","slotEditor_emptyState_no_visualization_selected_title":"Визуализация не отобрана","slotEditor_emptyState_no_visualization_selected_description":"Выберите визуализацию для управления настройками полей.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Выбранный виджет не использует поля","slotEditor_emptyState_widget_not_support_slot_selected_description":"Выберите визуализацию для управления настройками полей.","slotEditor_emptyState_multiple_visualizations_selected_title":"Выбрано несколько виджетов","slotEditor_emptyState_multiple_visualizations_selected_description":"Выберите визуализацию для управления настройками полей.","slotEditor_emptyState_visualization_has_error_title":"Вывести визуализацию невозможно","slotEditor_slotItem_tooltip":"Источник:","slotEditor_emptyState_vis_not_created_title":"Визуализация не создана","slotEditor_emptyState_vis_not_created_description":"Создайте визуализацию для управления настройками полей.","slotEditor":"Поля","slotEditorCoachMarkTitle":"Доступ к полям","slotEditorCoachMarkContents":"Добавьте в поля столбцы для построения и изменения визуализаций.","toolbarDeleteFilterActionText":"Удалить фильтр","toolbarActionFilter":"Фильтр","filterAutobinActionText":"Применить фильтр к контейнерам","coachMarkTitleSpiralTarget":"Изменить область","coachMarkContentSpiralTarget":"Здесь можно получить доступ и изменить выбор драйвера для целевого объекта.","overlayDropZonePlaceHolderText":"Перетащите сюда данные"},"__sl":{"localFilters":"Lokalni filtri","slotEditorMsg1":"Obvezno polje","slotEditorMsg2":"Povlecite in spustite podatke v polja zgoraj, da zgradite in filtrirate vizualizacijo.","missingColumn":"Manjkajoče: %{columnLabel}","placeholderDropzone":"Kliknite ali povlecite podatke sem","slotEditor_emptyState_no_visualization_selected_title":"Izbrana ni nobena vizualizacija","slotEditor_emptyState_no_visualization_selected_description":"Izberite vizualizacijo za upravljanje nastavitev polja.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Izbrani gradnik ne uporablja polj","slotEditor_emptyState_widget_not_support_slot_selected_description":"Izberite vizualizacijo za upravljanje nastavitev polja.","slotEditor_emptyState_multiple_visualizations_selected_title":"Izbranih je več gradnikov","slotEditor_emptyState_multiple_visualizations_selected_description":"Izberite vizualizacijo za upravljanje nastavitev polja.","slotEditor_emptyState_visualization_has_error_title":"Vizualizacije ni mogoče prikazati","slotEditor_slotItem_tooltip":"Izvor:","slotEditor_emptyState_vis_not_created_title":"Ustvarjena ni bila nobena vizualizacija","slotEditor_emptyState_vis_not_created_description":"Ustvarite vizualizacijo za upravljanje nastavitev polja.","slotEditor":"Polja","slotEditorCoachMarkTitle":"Polja za dostop","slotEditorCoachMarkContents":"V polja dodajte stolpce, da boste lahko gradili in spreminjali vizualizacije.","toolbarDeleteFilterActionText":"Odstrani filter","toolbarActionFilter":"Filter","filterAutobinActionText":"Predali filtra","coachMarkTitleSpiralTarget":"Urejanje območja","coachMarkContentSpiralTarget":"Tukaj lahko dostopate do izbora gonilnikov za svoj cilj in jih spreminjate.","overlayDropZonePlaceHolderText":"Povlecite podatke sem"},"__sv":{"localFilters":"Lokala filter","slotEditorMsg1":"Obligatoriskt fält","slotEditorMsg2":"Dra data till fälten ovan för att skapa och filtrera visualiseringen.","missingColumn":"%{columnLabel} saknas","placeholderDropzone":"Klicka eller dra data hit","slotEditor_emptyState_no_visualization_selected_title":"Ingen visualisering vald","slotEditor_emptyState_no_visualization_selected_description":"Välj en visualisering för att hantera fältinställningarna.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Den valda widgeten använder inte fält","slotEditor_emptyState_widget_not_support_slot_selected_description":"Välj en visualisering för att hantera fältinställningarna.","slotEditor_emptyState_multiple_visualizations_selected_title":"Flera widgetar har valts","slotEditor_emptyState_multiple_visualizations_selected_description":"Välj en visualisering för att hantera fältinställningarna.","slotEditor_emptyState_visualization_has_error_title":"Det går inte att visa visualiseringen","slotEditor_slotItem_tooltip":"Källa:","slotEditor_emptyState_vis_not_created_title":"Inga visualiseringar har skapats","slotEditor_emptyState_vis_not_created_description":"Skapa en visualisering för att hantera fältinställningarna.","slotEditor":"Fält","slotEditorCoachMarkTitle":"Åtkomst till fält","slotEditorCoachMarkContents":"Lägg till kolumner i fälten för att skapa och ändra visualiseringar.","toolbarDeleteFilterActionText":"Ta bort filter","toolbarActionFilter":"Filtrera","filterAutobinActionText":"Filtrera bin","coachMarkTitleSpiralTarget":"Ändra omfattning","coachMarkContentSpiralTarget":"Här kan du komma åt och ändra valet av styrfunktioner för målet.","overlayDropZonePlaceHolderText":"Dra data hit"},"__th":{"localFilters":"ตัวกรองโลคัล","slotEditorMsg1":"ฟิลด์ที่จำเป็น","slotEditorMsg2":"ลากและปล่อยข้อมูลลงในฟิลด์ด้านบนเพื่อบิลด์และกรองวิชวลไลเซชัน","missingColumn":"ไม่มี: %{columnLabel}","placeholderDropzone":"คลิกหรือลากข้อมูลที่นี่","slotEditor_emptyState_no_visualization_selected_title":"ไม่ได้เลือกวิชวลไลเซชัน","slotEditor_emptyState_no_visualization_selected_description":"เลือกวิชวลไลเซชันที่จะจัดการการตั้งค่าฟิลด์","slotEditor_emptyState_widget_not_support_slot_selected_title":"วิดเจ็ตที่เลือกไม่ได้ใช้ฟิลด์","slotEditor_emptyState_widget_not_support_slot_selected_description":"เลือกวิชวลไลเซชันที่จะจัดการการตั้งค่าฟิลด์","slotEditor_emptyState_multiple_visualizations_selected_title":"เลือกหลายวิดเจ็ต","slotEditor_emptyState_multiple_visualizations_selected_description":"เลือกวิชวลไลเซชันที่จะจัดการการตั้งค่าฟิลด์","slotEditor_emptyState_visualization_has_error_title":"วิชวลไลเซชันไม่สามารถแสดงผลได้","slotEditor_slotItem_tooltip":"ซอร์ส:","slotEditor_emptyState_vis_not_created_title":"ไม่มีการสร้างวิชวลไลเซชัน","slotEditor_emptyState_vis_not_created_description":"สร้างวิชวลไลเซชันที่จะจัดการการตั้งค่าฟิลด์","slotEditor":"ฟิลด์","slotEditorCoachMarkTitle":"เข้าถึงฟิลด์","slotEditorCoachMarkContents":"เพิ่มคอลัมน์ลงในฟิลด์เพื่อบิลด์และปรับเปลี่ยนวิชวลไลเซชัน","toolbarDeleteFilterActionText":"ลบตัวกรอง","toolbarActionFilter":"ตัวกรอง","filterAutobinActionText":"ถังกรอง","coachMarkTitleSpiralTarget":"แก้ไขขอบเขต","coachMarkContentSpiralTarget":"นี่เป็นตำแหน่งที่คุณสามารถเข้าถึงและปรับเปลี่ยนการเลือกไดรเวอร์สำหรับเป้าหมายของคุณ","overlayDropZonePlaceHolderText":"ลากข้อมูลที่นี่"},"__tr":{"localFilters":"Yerel süzgeçler","slotEditorMsg1":"Zorunlu alan","slotEditorMsg2":"Görselleştirmeyi oluşturup süzgeçten geçirmek için verileri yukarıdaki alanlara sürükleyip bırakın.","missingColumn":"Eksik: %{columnLabel}","placeholderDropzone":"Tıklatın veya verileri buraya sürükleyin","slotEditor_emptyState_no_visualization_selected_title":"Bir görselleştirme seçilmedi","slotEditor_emptyState_no_visualization_selected_description":"Alan ayarlarını yönetmek için bir görselleştirme seçin.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Seçilen pencere öğesi alanları kullanmıyor","slotEditor_emptyState_widget_not_support_slot_selected_description":"Alan ayarlarını yönetmek için bir görselleştirme seçin.","slotEditor_emptyState_multiple_visualizations_selected_title":"Birden çok pencere öğesi seçildi","slotEditor_emptyState_multiple_visualizations_selected_description":"Alan ayarlarını yönetmek için bir görselleştirme seçin.","slotEditor_emptyState_visualization_has_error_title":"Görselleştirme görüntülenemiyor","slotEditor_slotItem_tooltip":"Kaynak:","slotEditor_emptyState_vis_not_created_title":"Bir görselleştirme oluşturulmadı","slotEditor_emptyState_vis_not_created_description":"Alan ayarlarını yönetmek için bir görselleştirme oluşturun.","slotEditor":"Alanlar","slotEditorCoachMarkTitle":"Erişim alanları","slotEditorCoachMarkContents":"Görselleştirmeleri oluşturmak ve değiştirmek için alanlara sütun ekleyin.","toolbarDeleteFilterActionText":"Süzgeci kaldır","toolbarActionFilter":"Süzgeç","filterAutobinActionText":"Süzgeç bölmeleri","coachMarkTitleSpiralTarget":"Kapsamı düzenle","coachMarkContentSpiralTarget":"Burası, hedefiniz için sürücü seçimine erişebileceğiniz ve sürücü seçimini değiştirebileceğiniz yerdir.","overlayDropZonePlaceHolderText":"Verileri buraya sürükleyin"},"__zh":{"localFilters":"本地过滤器","slotEditorMsg1":"必填字段","slotEditorMsg2":"将数据拖放到字段上方可构建并过滤可视化。","missingColumn":"缺少：%{columnLabel}","placeholderDropzone":"单击数据或将数据拖到此处","slotEditor_emptyState_no_visualization_selected_title":"未选择任何可视化","slotEditor_emptyState_no_visualization_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_widget_not_support_slot_selected_title":"所选窗口小部件不使用字段","slotEditor_emptyState_widget_not_support_slot_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_multiple_visualizations_selected_title":"已选择多个窗口小部件","slotEditor_emptyState_multiple_visualizations_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_visualization_has_error_title":"无法显示可视化","slotEditor_slotItem_tooltip":"源：","slotEditor_emptyState_vis_not_created_title":"未创建任何可视化","slotEditor_emptyState_vis_not_created_description":"创建可视化以管理字段设置。","slotEditor":"字段","slotEditorCoachMarkTitle":"访问字段","slotEditorCoachMarkContents":"向字段添加列以构建并修改可视化。","toolbarDeleteFilterActionText":"除去过滤器","toolbarActionFilter":"过滤器","filterAutobinActionText":"过滤分箱","coachMarkTitleSpiralTarget":"编辑作用域","coachMarkContentSpiralTarget":"您可以在此访问和修改目标的动因选择。","overlayDropZonePlaceHolderText":"将数据拖到此处"},"__zh-cn":{"localFilters":"本地过滤器","slotEditorMsg1":"必填字段","slotEditorMsg2":"将数据拖放到字段上方可构建并过滤可视化。","missingColumn":"缺少：%{columnLabel}","placeholderDropzone":"单击数据或将数据拖到此处","slotEditor_emptyState_no_visualization_selected_title":"未选择任何可视化","slotEditor_emptyState_no_visualization_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_widget_not_support_slot_selected_title":"所选窗口小部件不使用字段","slotEditor_emptyState_widget_not_support_slot_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_multiple_visualizations_selected_title":"已选择多个窗口小部件","slotEditor_emptyState_multiple_visualizations_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_visualization_has_error_title":"无法显示可视化","slotEditor_slotItem_tooltip":"源：","slotEditor_emptyState_vis_not_created_title":"未创建任何可视化","slotEditor_emptyState_vis_not_created_description":"创建可视化以管理字段设置。","slotEditor":"字段","slotEditorCoachMarkTitle":"访问字段","slotEditorCoachMarkContents":"向字段添加列以构建并修改可视化。","toolbarDeleteFilterActionText":"除去过滤器","toolbarActionFilter":"过滤器","filterAutobinActionText":"过滤分箱","coachMarkTitleSpiralTarget":"编辑作用域","coachMarkContentSpiralTarget":"您可以在此访问和修改目标的动因选择。","overlayDropZonePlaceHolderText":"将数据拖到此处"},"__zh-tw":{"localFilters":"本端過濾器","slotEditorMsg1":"必要欄位","slotEditorMsg2":"將資料拖放至上方的欄位來建置及過濾視覺化。","missingColumn":"遺漏：%{columnLabel}","placeholderDropzone":"在這裡按一下或拖曳資料","slotEditor_emptyState_no_visualization_selected_title":"未選取任何視覺化","slotEditor_emptyState_no_visualization_selected_description":"選取視覺化以管理欄位設定。","slotEditor_emptyState_widget_not_support_slot_selected_title":"選取的小組件沒有使用欄位。","slotEditor_emptyState_widget_not_support_slot_selected_description":"選取視覺化以管理欄位設定。","slotEditor_emptyState_multiple_visualizations_selected_title":"已選取多個小組件","slotEditor_emptyState_multiple_visualizations_selected_description":"選取視覺化以管理欄位設定。","slotEditor_emptyState_visualization_has_error_title":"無法顯示視覺化。","slotEditor_slotItem_tooltip":"來源：","slotEditor_emptyState_vis_not_created_title":"未建立任何視覺化","slotEditor_emptyState_vis_not_created_description":"建立視覺化以管理欄位設定。","slotEditor":"欄位","slotEditorCoachMarkTitle":"存取欄位","slotEditorCoachMarkContents":"將直條圖新增至欄位以建置和修改視覺化。","toolbarDeleteFilterActionText":"移除過濾器","toolbarActionFilter":"過濾","filterAutobinActionText":"過濾組","coachMarkTitleSpiralTarget":"編輯範圍","coachMarkContentSpiralTarget":"您可以在此處存取及修改目標動因選項。","overlayDropZonePlaceHolderText":"將資料拖曳至此"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_19__;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)(false);
// imports


// module
exports.push([module.i, "/**\n * Licensed Materials - Property of IBM\n * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2020\n * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.\n */\n\n.widget.liveWidget.draggedOn .overlayDropZone {\n  opacity: 0.2;\n}\n\n.liveWidgetContent .dataview.notOnFocus {\n  opacity: 0.2;\n}\n\n.dropZoneOverlay {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow: hidden;\n  min-height: 250px;\n  min-width: 250px;\n}\n\n.dropZoneOverlay .smallView .overlayContainerMultiple .overlayDropZone:last-child {\n  display: none;\n}\n\n.dropZoneOverlay.hidden {\n  display: none;\n}\n\n.dropZoneOverlay .overlayView {\n  height: 100%;\n}\n\n.dropZoneOverlay .overlayContainer {\n  height: 100%;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n\n.dropZoneOverlay .overlayContainer .section_left,\n.dropZoneOverlay .overlayContainer .section_right {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.dropZoneOverlay .overlayContainer .section_left .overlayContainer_left,\n.dropZoneOverlay .overlayContainer .section_left .overlayContainer_right,\n.dropZoneOverlay .overlayContainer .section_right .overlayContainer_left,\n.dropZoneOverlay .overlayContainer .section_right .overlayContainer_right {\n  transform-origin: bottom;\n  transform: rotate(-90deg);\n  position: absolute;\n  top: 30%;\n  min-width: 160px;\n}\n\n.dropZoneOverlay .overlayContainer .section_left .overlayContainer_left,\n.dropZoneOverlay .overlayContainer .section_right .overlayContainer_left {\n  left: -20px;\n}\n\n.dropZoneOverlay .overlayContainer .section_left {\n  -ms-flex-preferred-size: 64px;\n      flex-basis: 64px;\n}\n\n.dropZoneOverlay .overlayContainer .section_right {\n  -ms-flex-preferred-size: 84px;\n      flex-basis: 84px;\n}\n\n.dropZoneOverlay .overlayContainer .overlayContainerMiddle {\n  -ms-flex-direction: column;\n      flex-direction: column;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-positive: 2;\n      flex-grow: 2;\n}\n\n.dropZoneOverlay .overlayContainer .overlayContainerMiddle .overlayContainer_top,\n.dropZoneOverlay .overlayContainer .overlayContainerMiddle .overlayContainer_bottom {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.dropZoneOverlay .overlayContainer .overlayContainerMiddle .overlayContainer_top .overlayContainerMultiple,\n.dropZoneOverlay .overlayContainer .overlayContainerMiddle .overlayContainer_bottom .overlayContainerMultiple {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n}\n\n.dropZoneOverlay .overlayContainer .overlayDropZone {\n  max-width: 256px;\n  min-width: 97px;\n  margin-bottom: 8px;\n  margin-left: 8px;\n  -ms-flex-positive: 1;\n      flex-grow: 1;\n}\n\n.dropZoneOverlay .overlayDropZone .overlayDropZoneCaption {\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.dropZoneOverlay .overlayDropZone .overlayDropZoneCaption .overlayDropZoneCaptionRequiredStar {\n  color: #da1e28;\n  color: hsla(var(--support-01-h, 356.80851), var(--support-01-s, 75.80645%), var(--support-01-l, 48.62745%), 1);\n  padding-right: 4px;\n}\n\n.dropZoneOverlay .overlayDropZone .overlayDropZonePlaceHolder {\n  height: 32px;\n  outline: 1px dashed;\n  outline-color: #8d8d8d;\n  outline-color: hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1);\n  background-color: white;\n  background-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.dropZoneOverlay .overlayDropZone .overlayDropZonePlaceHolder.dndHover {\n  outline: 2px solid;\n  outline-color: #0f62fe;\n  outline-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n}\n\n.dropZoneOverlay .overlayDropZone .overlayDropZonePlaceHolder.dndHover .overlayDropZonePlaceHolderText {\n  color: #0f62fe;\n  color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  text-decoration: underline;\n}\n\n.dropZoneOverlay .overlayDropZone .overlayDropZonePlaceHolder.dndHover .overlayDropZoneItemsInsertAfter {\n  background-color: #0f62fe;\n  background-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n}\n\n.dropZoneOverlay .overlayDropZone .overlayDropZonePlaceHolder .overlayDropZonePlaceHolderText {\n  font-size: 12px;\n  color: #a8a8a8;\n  color: hsla(var(--text-03-h, 0), var(--text-03-s, 0%), var(--text-03-l, 65.88235%), 1);\n  margin: 8px 16px 0px 8px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dropZoneOverlay .overlayDropZone .overlayDropZonePlaceHolder .overlayDropZoneItems {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n\n.dropZoneOverlay .overlayDropZone .overlayDropZonePlaceHolder .overlayDropZoneItems .overlayDropZoneItemsInsertAfter {\n  padding: 0 1px;\n  margin: 8px 0 8px 2px;\n}\n\n.dropZoneOverlay .overlayDropZone .overlayDropZonePlaceHolder .overlayDropZoneItems .ba-common-tags__list {\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n}\n\n.dropZoneOverlay .overlayDropZone .overlayDropZonePlaceHolder .overlayDropZoneItems .ba-common-tags__list .ba-common-tags__listItem {\n  height: 16px;\n  padding: 4px;\n  margin: 4px;\n  color: #161616 true;\n  color: hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1) true;\n  background-color: white true;\n  background-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1) true;\n}\n\n.dropZoneOverlay .overlayDropZone .overlayDropZonePlaceHolder .overlayDropZoneItems .ba-common-tags__list .ba-common-tags__listItem .ba-common-truncatedText {\n  display: -ms-inline-flexbox !important;\n  display: inline-flex !important;\n}\n\n.darkTheme .dropZoneOverlay .overlayDropZone .overlayDropZoneCaption {\n  color: white;\n  color: hsla(var(--text-04-h, 0), var(--text-04-s, 0%), var(--text-04-l, 100%), 1);\n}\n\n.darkTheme .dropZoneOverlay .overlayDropZone .overlayDropZonePlaceHolder {\n  background-color: #161616;\n  background-color: hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1);\n}\n\n.darkTheme .dropZoneOverlay .overlayDropZone .overlayDropZonePlaceHolder .overlayDropZonePlaceHolderText {\n  color: white;\n  color: hsla(var(--text-04-h, 0), var(--text-04-s, 0%), var(--text-04-l, 100%), 1);\n}\n\n", ""]);

// exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(23);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 23 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SLOT_ITEM_TOUCH_DRAG_DURATION = 600;

var DndSlotItemHandler = function () {
	/**
  * DndSlotItemHandler hides most of the drag and drop handling used by the glass DndManager
  * It handles drop of data from the metadata tree to a Slot Item (or Slot Heading)
  * It also handles Drag&Drop of slot to slot data.
  *
  * @param {Object} 	options
  * @param {DOMNode} options.domNode - DOM node to attach drag and drop to
  * @param {string} 	options.className - class name
  * @param {Function} options.slotDataItemHandler - the slotDataItemHandler.
  * @param {Boolean}	options.addAfter - true if this drop is after a slot
  * @param {Object} 	options.dndManager - the drag&drop manager.
  * @param {Function} [options.onDragEnter] - oprional function to be executed in addition to activateDropTarget when entering this target
  * @param {Function} [options.onDragLeave] - oprional function to be executed in addition to activateDropTarget when exiting this target
  * @param {Boolean} [options.isVisOverlay] - if set, this target is a visOverlay....rules are determined in VisDnDManager.
  */
	function DndSlotItemHandler(options) {
		_classCallCheck(this, DndSlotItemHandler);

		this.domNode = options.domNode;
		this.className = options.className;

		this.slotDataItemHandler = options.slotDataItemHandler;

		this.addAfter = options.addAfter;
		this.dndManager = options.dndManager;
		this.onDragEnter = options.onDragEnter; //custom drag enter handling (in addition to activateDropTarget)
		this.onDragLeave = options.onDragLeave; //custom drag enter handling (in addition to deactivateDropTarget)
		this.isVisOverlay = options.isVisOverlay;
		this.timer = null;

		// Register slot as a drop target
		if (this.dndManager) {
			this._setupDnD();
		}
	}

	_createClass(DndSlotItemHandler, [{
		key: '_setupDnD',
		value: function _setupDnD() {
			var _this = this;

			var onDrop = this.slotDataItemHandler && this.slotDataItemHandler.onDrop && this.slotDataItemHandler.onDrop.bind(this.slotDataItemHandler);

			//NOTE: registering a new dropTarget on a node derigisters the old one.
			this.dndManager.registerDropTarget({
				el: this.domNode,
				type: 'slot.item',
				info: function info(domNode, event) {
					return {
						//position info
						dragInfo: {
							position: {
								x: event.clientX,
								y: event.clientY
							}
						},
						node: domNode,

						//drag&drop handlers
						onDragEnter: _this.activateDropTarget.bind(_this),
						onDragLeave: _this.deactivateDropTarget.bind(_this),
						onDrop: onDrop,

						//slot data variables.
						contentId: _this.slotDataItemHandler.getContentId(),
						slot: _this.slotDataItemHandler.getSlotAPI(),
						indexInSlot: _this.slotDataItemHandler.indexInSlot,
						addAfter: _this.addAfter,
						isVisOverlay: _this.isVisOverlay
					};
				}
			});
		}
	}, {
		key: 'destroy',
		value: function destroy() {
			this.dndManager.deregisterDropTarget(this.domNode);
		}
	}, {
		key: 'updateDropTarget',
		value: function updateDropTarget(slotDataItemHandler) {
			if (this.dndManager) {
				this.slotDataItemHandler = slotDataItemHandler;
				this._setupDnD();
			}
		}
	}, {
		key: 'activateDropTarget',
		value: function activateDropTarget() {
			(0, _jquery2.default)(this.domNode).toggleClass(this.className, true);
			if (this.onDragEnter) {
				this.onDragEnter();
			}
		}
	}, {
		key: 'deactivateDropTarget',
		value: function deactivateDropTarget() {
			(0, _jquery2.default)(this.domNode).toggleClass(this.className, false);
			if (this.onDragLeave) {
				this.onDragLeave();
			}
		}
	}, {
		key: 'onDragMove',
		value: function onDragMove(dragObject, dropNode, event) {
			var _this2 = this;

			var slotEditorNode = (0, _jquery2.default)(dropNode).closest('.slotEditor').get(0);
			if (slotEditorNode) {
				(0, _utils.handleScroll)(event, slotEditorNode, function () {
					return _this2.dndManager && _this2.dndManager.reassessContainer(slotEditorNode);
				});
			}
			this.activateDropTarget();
		}

		/**
   * @param dndManager - the dndManager to initialize the drag within
   * @param cbGetSlotDataItemHandler - a callback function which should be called when starting any drag to get the up-to-date item data handler.
   */

	}, {
		key: 'initializeDndSource',
		value: function initializeDndSource(dndManager, cbGetSlotDataItemHandler, iconsFeature, startDragCallBack) {
			var _this3 = this;

			// Separate mouse and touch event handlers for defect 241719
			(0, _jquery2.default)(this.domNode).on('mousedown', {}, function (event) {
				if (startDragCallBack) {
					startDragCallBack();
				}
				_this3._startDrag({
					dndManager: dndManager,
					event: event,
					cbGetSlotDataItemHandler: cbGetSlotDataItemHandler,
					iconsFeature: iconsFeature
				});
				return true;
			});

			(0, _jquery2.default)(this.domNode).on('touchstart', {}, function (event) {
				if (startDragCallBack) {
					startDragCallBack();
				}
				_this3._touchStart({
					dndManager: dndManager,
					event: event,
					cbGetSlotDataItemHandler: cbGetSlotDataItemHandler,
					iconsFeature: iconsFeature
				});
				return true;
			});

			(0, _jquery2.default)(this.domNode).on('touchend touchcancel', {}, function () {
				return _this3._touchEnd();
			});
		}

		// defect 241719
		// after touchstart, wait short time to start drag process if still touch,
		// so that it can reduce change of ambiguous event with scrolling of the slot editor

	}, {
		key: '_touchStart',
		value: function _touchStart(options) {
			this.timer = setTimeout(function () {
				this._touchStartDrag(options);
			}.bind(this), SLOT_ITEM_TOUCH_DRAG_DURATION);
		}
	}, {
		key: '_touchEnd',
		value: function _touchEnd() {
			if (this.timer) {
				clearTimeout(this.timer);
			}
			this.timer = null;
		}
	}, {
		key: '_touchStartDrag',
		value: function _touchStartDrag(options) {
			if (this.timer) {
				this._startDrag(options);
			}
		}
	}, {
		key: '_startDrag',
		value: function _startDrag(options) {
			var $avatar = (0, _jquery2.default)('<div style="position:absolute; z-index:10000;"/>');

			var $draggedNode = (0, _jquery2.default)(this.domNode).clone().addClass('draggedNode');

			var _domNode$getBoundingC = this.domNode.getBoundingClientRect(),
			    width = _domNode$getBoundingC.width;

			$draggedNode.css({
				width: width,
				cursor: 'default'
			});
			if (options.iconsFeature) {
				var disableIcon = options.iconsFeature.getIcon('common-nodrop');
				if (disableIcon) {
					var $nodropSign = (0, _jquery2.default)('<div class="nodrop is-hidden">\n\t\t\t\t\t\t<svg class="svgIcon">\n\t\t\t\t\t\t\t<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#' + disableIcon.id + '">\n\t\t\t\t\t\t\t</use>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t</div>');
					$draggedNode.find('.bi-common-field-item__nameLine__draggable').remove();
					$draggedNode.find('.bi-common-field-item__nameLine').prepend($nodropSign);
				}
			}
			$avatar.append($draggedNode);

			var sourceSlotDataItemHandler = options.cbGetSlotDataItemHandler();
			options.dndManager.startDrag({
				event: options.event,
				type: 'SLOT_ITEM',
				data: {
					source: {
						slot: sourceSlotDataItemHandler.getSlotAPI(),
						indexInSlot: sourceSlotDataItemHandler.indexInSlot
					}
				},
				callerCallbacks: {
					onMove: this._onMove.bind(this)
				},
				avatar: $avatar,
				moveXThreshold: 20,
				moveYThreshold: 20
			});
		}
	}, {
		key: '_onMove',
		value: function _onMove(event) {
			var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			var dragObject = payload.dragObject;

			if (dragObject) {
				var avatar = dragObject.avatar;

				if (avatar) {
					var $avatar = (0, _jquery2.default)(avatar);
					var $nodrop = $avatar.find('.nodrop');
					if ($nodrop.length) {
						var dropTargetNode = payload.dropTargetNode;

						if (!dropTargetNode) {
							// no payload.dropTargetNode means currenly you cannot drop here, so we show `not allowed drop sign`
							$nodrop.toggleClass('is-hidden', false);
						} else {
							// else payload.dropTargetNode exists,
							// if the drop target is not `.slotEditor` (which is used for drag auto scroll ),
							// then means currenly you can REALLY drop the slot item here, so we does not show `not allowed drop sign`
							var isDropTargetNotSlotEditor = !(dropTargetNode.classList && dropTargetNode.classList.contains('slotEditor'));
							$nodrop.toggleClass('is-hidden', isDropTargetNotSlotEditor);
						}
					}
				}
			}
		}
	}]);

	return DndSlotItemHandler;
}();

exports.default = DndSlotItemHandler;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_25__;

/***/ })
/******/ ])});;


// WEBPACK FOOTER //
// DropZonesOverlayDOM.js